import {
  backgroundStyle,
  items,
  myAddress,
  policy,
  profileContentManagement,
  subscriptionBuy,
  thirdPartyLogin,
  voucher,
} from './constant';

export default {
  pc: {
    [backgroundStyle]: {
      image: null,
      primaryColor: '#000000',
      textColor: '#ffffff',
      tabColor: '#000000',
    },
    [policy]: {
      [items]: [],
    },
    [profileContentManagement]: {
      [subscriptionBuy]: false,
      [voucher]: false,
      [myAddress]: false,
      [thirdPartyLogin]: false,
    },
  },
  tablet: {
    [backgroundStyle]: {
      image: null,
      primaryColor: '#000000',
      textColor: '#ffffff',
      tabColor: '#000000',
    },
    [policy]: {
      [items]: [],
    },
    [profileContentManagement]: {
      [subscriptionBuy]: false,
      [voucher]: false,
      [myAddress]: false,
      [thirdPartyLogin]: false,
    },
  },
  mobile: {
    [backgroundStyle]: {
      image: null,
      primaryColor: '#000000',
      textColor: '#ffffff',
      tabColor: '#000000',
    },
    [policy]: {
      [items]: [],
    },
    [profileContentManagement]: {
      [subscriptionBuy]: false,
      [voucher]: false,
      [myAddress]: false,
      [thirdPartyLogin]: false,
    },
  },
};
